import {  Hct, argbFromHex, hexFromArgb } from '@material/material-color-utilities'

import googleDataSelector from './data-selector.js'

const getGoogleBackgroundColour = ({ googleClass, googleObject, variables, googlePassType }) => {

  try {
    switch (googlePassType) {
      case "generic":
        {
          return googleDataSelector({ objectData:googleObject, variables, path: "hexBackgroundColor" })
        }

        // These can have colours defined in class or object but we are only going to support object
      case "flight":
      case "transit":
      case "eventTicket":
        {
          return googleDataSelector({ objectData:googleObject,  variables, path: "hexBackgroundColor" })
        }

      // These can only have background colour defined in class
      case "giftCard":
      case "loyalty":
      case "offer":
        {
          return googleDataSelector({ objectData:googleClass, variables, path: "hexBackgroundColor" })
        }
    }
  }
  catch (err) {
    throw err
  }
}

const getGoogleDarkBackgroundColour = ({ googleBackgroundColour }) => {

  if (!googleBackgroundColour) return "#000000"

  const source = Hct.fromInt(argbFromHex(googleBackgroundColour))

  let chroma = source.chroma;
  let tone = source.tone;

  if (source.chroma > 40) {
    // Strong colours
    chroma *= 0.95;
    tone -= 5;
  } else {
    // Neutral / pastel colours
    tone *= 0.93;
  }

  const result = Hct.from(
    source.hue,
    chroma,
    Math.max(0, tone)
  );

  return hexFromArgb(result.toInt());
}

// Automatically determine whether to use Black or White as the foreground colour.
// Hopefully matches what Google do... 

const contrastColor = ({
  bgColor = '#FFFFFF',
  fgDarkColor = '#000000',
  fgLightColor = '#FFFFFF',
  defaultColor = '#000000',
} = {}) => {
  try {
    const tone = Hct.fromInt(argbFromHex(bgColor)).tone;

    return tone >= 75
      ? fgDarkColor
      : fgLightColor;
  } catch {
    return defaultColor;
  }
};



export {
  getGoogleBackgroundColour,
  getGoogleDarkBackgroundColour,
  contrastColor
}


